
export class SiteForm {
  id: number;
  name: string;
  version: number;
  versionId: number;
  createdDate: Date;
  lastModifiedDate: Date;
  data: { [key: string]: any }[];
  linkedSites: {siteId:number, siteName: string}[] = [];
  siteOwnerSkylarkUser: number;
  siteOwnerName: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.name = input.name;
    this.version = input.siteFormVersion.versionNum;
    this.versionId = input.siteFormVersion.id;
    this.createdDate = new Date(input.createdDate);
    this.lastModifiedDate = new Date(input.siteFormVersion.createdDate);
    this.siteOwnerSkylarkUser = input.siteOwnerSkylarkUserId;
    this.siteOwnerName = input.siteOwnerName;

    try {
      this.data = JSON.parse(input.siteFormVersion.formData);
    } catch (e) {
      this.data = [
        {
          "type": "headerLarge",
          "text": "Invalid form data"
        }
      ];
    }

    this.linkedSites = input.sites.map(site => {
      return {
        siteName: site.name,
        siteId: site.id
      }
    }).sort((a, b) => a.siteName.localeCompare(b.siteName));

    return this;
  }
};
